import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { DefaultErrorComponent } from './default.error.component';

const routes: Routes = [
   { path: '**', component: DefaultErrorComponent },
];

@NgModule({
   imports: [RouterModule.forChild(routes)],
   exports: [RouterModule]
})
export class DefaultErrorRoutingModule { }
